import React from 'react'
import logoImg from "../../static/images/logo.png";
export default function DefaultLoading() {
    return (
        <div className='default-loader'>
            <img alt='logo' className="logo default-loading-icon" src={logoImg}/>
        </div>
    )
}
